import styled from 'styled-components'
import { colors, spacing } from '../../styles/_var'

export const SidebarContent = styled.div`
  padding: ${spacing.xs};
  border: solid 1px ${colors.lightgrey};
  border-radius: 4px;
  margin-bottom: ${spacing.sm};
`
